import React, { useContext, useState } from 'react'
import Back from '../../components/Header/Back'
import Profile from '../../assests/images/profile_2.png'
import Swal from 'sweetalert2';
import Edit from '../../assests/images/edit.svg'
import {URl} from "../../utils/Common";
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom'
import { DataContext } from '../../context/DataContext';
import Footer from '../footer/Footer';
const EditProfile = () => {
      const [profilePic, setProfilePic] = useState(null); //
      const [fill, Setfill] = useState(false);
      const [selectedImage, setSelectedImage] = useState(''); // State to store the selected image
      const [errors, setErrors] = useState({});
      const [UserName, SetUserName] = useState('');
      const [isLoading, setIsLoading] = useState(false);
      const [show, SetShow] = useState(false);
      const {state} = useLocation();
      const name =state.name
      const picture=state.pic
      const { data, loading, error, refetch } = useContext(DataContext);
      const nav=useNavigate()
  const handleImageChange = (e) => {
    Setfill(true);
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file)
      const reader = new FileReader();
      reader.onload = () => {
        setProfilePic(reader.result); 
      };
      reader.readAsDataURL(file); 
    }
  };
   const handleUploadClick = () => {
    document.getElementById("fileInput").click();
  };

   const SuccessHandler = () => {
    Swal.fire({
      title: "Updated  Successfully",
      icon: "success",
      allowOutsideClick: false,
      showConfirmButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        nav('/Profile')
      }
    });
  }
   const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm({UserName,selectedImage});
    setErrors(newErrors);
    const formData = new FormData();
    formData.append('user_image',(!selectedImage)?picture:selectedImage);
    formData.append('user_name', (!UserName)?name:UserName);
    formData.append('user_id', data?data.user_id:'');
    if (Object.keys(newErrors).length<=1 &&fill) {
      setIsLoading(true)
      SetShow(true)
      try {
        const response = await axios.post(`${URl}/Userheaderdetail/userProfileEdit/`, formData, {
          headers: {
            'Content-Type': "multipart/form-data",
            'Idtoken': `${data?data.idtoken:''}`,
          },
        });
        if (response.data.status == 1) {
          SuccessHandler()
        }
        console.log(response.data.message)
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    } else {
      console.log('Form submission failed due to validation errors.');
  }
    };
    const validateForm = (data) => {
      const errors = {};
      if (!data.UserName.trim()) {
        errors.UserName = 'Username is required';
      } else if (data.UserName.length < 4) {
        errors.UserName = 'Username must be at least 4 characters long';
      }
      else if(data.UserName.indexOf(" ") !== -1){
        errors.UserName = 'Space not Allowed';
      }
      if (!data.selectedImage) {
        errors.image = 'Image is required';
      } 
      return errors;
    };
const back = () => {
    nav('/Profile')
  };
  return (
 <>
    <Back url={'/profile'}></Back>
    <div className="body_area22">
      <div className="cointainr">
        <div className="column_area">
          <form onSubmit={handleSubmit}>
          <div className="edit_prfle">
            <div className="user_img_ed">
              <img
                src={profilePic == null ? `${picture}` : `${profilePic}`} onClick={handleUploadClick}
                alt="user"
                className="user_img_edit"
              />
              <img src={Edit} alt="edit" className="edit_ic" onClick={handleUploadClick} />
            <input class="file-upload" type="file" accept="image/*" id="fileInput" onChange={handleImageChange} />
            	{!fill&&errors.image && (
							<span className="error-message err_2">
							{errors.image}
							</span>
						)}
            </div>
            <input type='text' placeholder={name} className='validate input_name' value={UserName}
						onChange={(e) => SetUserName(e.target.value,Setfill(true))} ></input>
						{errors.UserName && (
						<span className="error-message">
							{errors.UserName}
						</span>
						)}
            <input
              placeholder="Enter Email Id"
              id="first_name"
              type="email"
              className="validate input_name"
            />
						{show&&<button class="play_now mrgn0 disable" type="button">Save Changes</button>
						}
						{!show&&<button class="play_now mrgn0 btn_gren " type="submit">Save Changes</button>
						}
            <button className="play_now completed_btn mrgn0" onClick={back}>Cancel</button>
            {/* <button className="play_now mrgn0">Save Changes</button>
            <button className="play_now completed_btn mrgn0">Cancel</button> */}
          </div>
          </form>
        </div>
        <Footer></Footer>
      </div>
    </div>
</>

  )
}

export default EditProfile
